import React from 'react';
import urls from '../configs/urls'
import User from '../Modules/User'
import {Redirect} from 'react-router'
import '../css/App.css';
import '../css/MainMenu.css';
import ls from 'local-storage'
import axios from 'axios';
import Loading from "./Loading";
import Retry from "./Retry";
import MenuItem from "../Modules/MenuItem";
import TopNav from "./TopNav";
import AppBody from "./AppBody";
import CustomSlider from "./CustomSlider";
import MainMenuItem from "./MainMenuItem";
import Product from "../Modules/Product";

class MainMenu extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            retry: false,
            url:"",
            loading: true,
            gotUser:false,
            badUser:false,
            user:new User(),
            categoryList: [],
            images:[],
            items:[],
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount = () => {

        this.getUserData();

    };
    componentDidMount() {

        if(this.props.match.params.from_notification){
            this.props.history.push("/"+this.props.match.params.from_notification);
        }
    }


    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        return this.renderContent()

    }

    renderContent(){
        if(!this.state.gotUser)
            return (
                <div className="App-body" >
                    <div className={"infoMessage"}>
                        درحال دریافت اطلاعات
                    </div>
                </div>
            );


        if(this.state.badUser)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                    اطلاعات کاربری ناقص است. لطفا مجددا وارد شوید.
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );




        return (
            <AppBody loading={this.state.loading} showBotNav={true} name={"صفحه اصلی ( "+ls.get('city_name') +" )"} type={" bg-white"}>
                <CustomSlider slides={this.state.images}/>
                {this.renderCats()}
                <div id={"MainMenuItems"}>
                    {this.renderItems()}
                </div>
            </AppBody>
        );
    }

    getCatShopData(){
        this.setState({loading:true});

        axios.get(urls.baseUrl+urls.getAllCategoriesOfStore_V96+"?token="+ls.get("token")+"&city_id"+ls.get("city_id"))
            .then(res => {
                if(res.data.code == 200){
                    this.setState({categoryList:res.data.catshop.data,loading:false,images:res.data.sliders,items:res.data.items});
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,loading:false});
            });
    }

    renderCats(){
        return this.state.categoryList.map((data)=>{
            return (
                <div className={"catShopElm"} onClick={()=>this.handleShops(data.id)}>
                    <div className={"catShopImgElm"}>
                        <img className={"catShopImg"} src={urls.SiteUrl+"upload/"+data.img}/>
                    </div>
                    <div className={"catShopText"}>{data.cat_name}</div>
                </div>
            )
        });
    }
    renderItems(){
        return this.state.items.map((data)=>{
            return (
                <MainMenuItem item={data}/>
            )
        });
    }

    getUserData(){
        axios.get(urls.baseUrl+urls.checkClient+"?token="+ls.get("token"))
            .then(res => {
                if(res.data.code == 200){
                    let user = new User();
                    user.setData(res.data.user);
                    user.balance = res.data.wallet.balance;
                    user.countUnreadMessages = res.data.countUnreadMessages;
                    ls.set("user",user);
                    ls.set("city_id",user.city_id);
                    this.setState({gotUser:true,badUser:false});
                    this.getCatShopData();
                }
                else{
                    ls.remove("user");
                    ls.remove("token");
                    ls.remove("phone");
                    this.setState({retry:false,gotUser:true,badUser:true,loading:false});
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({retry:true,gotUser:false,badUser:true,loading:false});
            });
    }

    handleSubmit(event){
        event.preventDefault();
        this.props.history.push('/');
    }
    handleShops(shopId){
        ls.set("cat_id",shopId);
        this.props.history.push({
            pathname: '/stores',
            state: {id:shopId}
        });
    }



}



export default MainMenu;
